export default __webpack_public_path__ + "static/media/food-details.68aa88cb.png";